<template>
  <v-dialog
    v-model="visible"
    :max-width="width"
    @keydown.esc="reject()"
    @keydown.enter="accept()"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <v-card>
      <v-card-title class="headline">
        <v-spacer></v-spacer>
        {{ caption }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <div>
          <p>Want an app to be added to {{ $t('Common.title') }}?</p>
          <p>
            {{ $t('Common.title') }} platform is offered to you as is and for free by
            <a href="https://www.assistedcoding.eu">assistedcoding.eu</a>
          </p>

          <p>
            However, if you have a neat idea we will be happy to implement it !
            If you want an app to be added you should definitely let us know !!!
          </p>

          <p>To let us know of your idea you could do one of the following:</p>

          <ul>
            <li>
              send us a message via the official
              <a href="https://www.assistedcoding.eu/contact">contact page</a>
            </li>
            <li>
              create a ticket at
              <a href="https://assistedcoding.freshdesk.com"
                >the official support system</a
              >
            </li>
          </ul>

          <br />
          <p>Thank you for using {{ $t('Common.title') }} !</p>
          <p>Have fun !!</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" :color="acceptColor" @click="accept()">{{
          acceptPrompt
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    acceptColor: {
      type: String,
      required: false,
      default: "success"
    },
    rejectColor: {
      type: String,
      required: false,
      default: "red darken-1"
    },
    acceptPrompt: {
      type: String,
      required: false,
      default: "OK"
    },
    rejectPrompt: {
      type: String,
      required: false,
      default: "No"
    }
  },
  data() {
    return {
      width: 540,
      visible: false,
      value: "",
      caption: "Request for an app",
      text: "",
      promise: null,
      promiseResolve: null,
      promiseReject: null
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.promise = new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;
      });
      return this.promise;
    },
    accept() {
      this.visible = false;
      this.promiseResolve(this.value);
    },
    reject() {
      this.visible = false;
      this.promiseReject(this.value);
    }
  }
};
</script>
